module.exports = __webpack_public_path__ + "static/media/jonathan-retro.70640a03.jpg";